export default __webpack_public_path__ + "static/cache-policy-ca9067cd1f8e0f077a0ed19abb5f6bac.png";